import script from "./BodorGptPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BodorGptPage.vue?vue&type=script&setup=true&lang=js"

import "./BodorGptPage.vue?vue&type=style&index=0&id=3dd746ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dd746ae"]])

export default __exports__